import React from "react";

function Aquarius({}) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.158 496.158"
      enableBackground="new 0 0 496.158 496.158"
    >
      <path
        fill="#F9DC5F"
        d="M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
      />
      <path
        fill="#A3947C"
        d="M235.765,118.016c-0.525-0.524-2.584-2.584-3.109-3.109c-9.275-9.274-36.705,3.118-61.262,27.676
	c-24.559,24.56-36.951,51.987-27.676,61.262c0.525,0.524,2.584,2.584,3.109,3.109c9.273,9.274,36.701-3.118,61.26-27.677
	C232.646,154.719,245.038,127.29,235.765,118.016z"
      />
      <path
        fill="#918169"
        d="M171.393,142.583c-24.559,24.56-36.951,51.987-27.676,61.262c0.525,0.524,2.584,2.584,3.109,3.109
	c9.273,9.274,36.701-3.118,61.26-27.677L171.393,142.583z"
      />
      <rect
        x="158.155"
        y="170.332"
        transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 478.4516 157.8728)"
        fill="#A3947C"
        width="96.749"
        height="15.391"
      />
      <rect
        x="165.097"
        y="187.087"
        transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 461.6841 198.3306)"
        fill="#918169"
        width="49.34"
        height="15.393"
      />
      <path
        fill="#A3947C"
        d="M412.991,305.866l-38.188-86.822c-34.924-63.343-72.076-80.919-72.076-80.919
	c-19.988-8.62-64.943,9.59-64.943,9.59l-30.794,29.58l-0.015-0.016l-0.373,0.388l-0.387,0.372l0.016,0.016l-29.582,30.794
	c0,0-18.207,44.952-9.588,64.941c0,0,17.578,37.155,80.92,72.075l86.822,38.188c0,0,22.146,4.738,52.385-25.044l0.011,0.011
	c0.13-0.129,0.247-0.256,0.372-0.384c0.131-0.128,0.259-0.246,0.387-0.375l-0.01-0.011
	C417.729,328.013,412.991,305.866,412.991,305.866z"
      />
      <path
        fill="#918169"
        d="M387.948,358.25c0.01,0.011-180.958-180.956-180.958-180.956l-0.015-0.016l-0.373,0.388l-0.387,0.372
	l0.016,0.016l-29.582,30.795c0,0-18.207,44.952-9.588,64.941c0,0,17.578,37.155,80.92,72.075l86.822,38.188
	c0,0,22.146,4.738,52.385-25.044l0.011,0.011c0.13-0.129,0.247-0.256,0.372-0.384c0.131-0.128,0.259-0.246,0.387-0.375
	L387.948,358.25z"
      />
      <path
        fill="#414140"
        d="M224.421,123.141c-7.558-7.558-29.908,2.541-49.918,22.552
	c-20.012,20.012-30.109,42.361-22.553,49.918c7.557,7.557,29.906-2.541,49.92-22.552
	C221.878,153.048,231.977,130.698,224.421,123.141z"
      />
      <path
        fill="#A3947C"
        d="M394.7,162.184c-16.23-30.965-51.829-44.304-79.51-29.794c-27.682,14.51-36.963,51.375-20.73,82.34
	c16.23,30.966,51.829,44.305,79.51,29.795C401.653,230.014,410.933,193.15,394.7,162.184z M365.004,227.419
	c-19.237,10.084-43.976,0.814-55.254-20.705c-11.278-21.517-4.831-47.135,14.406-57.219c19.235-10.083,43.974-0.813,55.254,20.706
	C390.69,191.718,384.239,217.336,365.004,227.419z"
      />
      <path
        fill="#918169"
        d="M243.349,265.842c-30.966-16.232-67.83-6.951-82.34,20.731c-14.51,27.68-1.172,63.279,29.793,79.51
	c30.966,16.232,67.83,6.951,82.342-20.731C287.652,317.671,274.313,282.073,243.349,265.842z M256.037,336.385
	c-10.083,19.235-35.7,25.687-57.218,14.406c-21.52-11.279-30.788-36.018-20.705-55.253c10.084-19.236,35.701-25.686,57.219-14.406
	S266.121,317.149,256.037,336.385z"
      />
      <path
        fill="#98CAD8"
        d="M205.835,169.055c0,0-38.207,3.371-61.805,15.17c0,0-72.666,41.015-59.557,111.809
	c13.111,70.793,58.621,78.659,69.297,77.536c0,0-23.973-80.907-5.619-124.356C166.423,205.958,205.835,169.055,205.835,169.055z"
      />
      <path
        fill="#C1DFE8"
        d="M126.053,210.257c-20.977,16.481-39.058,36.824-35.21,78.659
	c5.994,65.175,53.938,77.161,53.938,77.161C83.351,305.398,126.053,210.257,126.053,210.257z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Aquarius;
